import { render, staticRenderFns } from "./DevicePagesBase.vue?vue&type=template&id=5a925848&scoped=true&"
import script from "./DevicePagesBase.vue?vue&type=script&lang=js&"
export * from "./DevicePagesBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a925848",
  null
  
)

export default component.exports